import i18n from '../../i18n';

/** 留言、許願的時間：依介面語言顯示（原本寫死 zh-TW，英日文介面也顯示中文日期） */
export const formatDateTime = (iso: string) =>
  new Date(iso).toLocaleString(i18n.language === 'zh' ? 'zh-TW' : i18n.language, {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
  });
